import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import IconClose from '../../icons/IconClose';
import './index.scss';
import { textLang } from './textLang';

export default function WinVisitPage({
    callback,
    gainConfig,
    signInCampaignId,
    item,
}: {
    callback: any;
    gainConfig?: any;
    signInCampaignId?: string;
    item?: any;
}) {
    const { locale = 'us', pathname } = useRouter();
    const gainConfigArr = `${gainConfig || ''}`.split(',');

    const gainConfig2 = {
        seconds: gainConfigArr[1] || 0,
        href: `${gainConfigArr[0]}`,
    };
    const hrefItem = `${gainConfig2.href}?signInCampaignId=${signInCampaignId}&redirect=/${locale}${pathname}&date=${item.dateString}`;

    const TextA = textLang[locale] || textLang['us'];
    const refDialog = useRef<any>(null);
    const closeHandle = () => {
        callback && callback();
    };
    useEffect(() => {
        refDialog.current.showModal();
    }, []);
    return (
        <dialog className="ef-check-in-dialog ef-check-in-dialog-WinVisitPage" ref={refDialog}>
            <div className="ef-check-in-dialog-wrap">
                <div className="ef-check-in-dialog-body">
                    <div className="ef-check-in-dialog-title">{TextA.title}</div>
                    <button className="ef-check-in-dialog-close" onClick={closeHandle}>
                        <IconClose />
                    </button>
                    <div className="ef-check-in-dialog-WinVisitPage-box">
                        <div className="ef-check-in-dialog-WinVisitPage-box-ms1">
                            {TextA.desc1}
                            {gainConfig2.seconds}
                            {TextA.desc2}
                        </div>
                        <div className="ef-check-in-dialog-footer">
                            <EfLink
                                className="ef-check-in-dialog-btn"
                                href={hrefItem}
                                onClick={closeHandle}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'jump_button',
                                    position: 'Make up for check-in',
                                    button_name: TextA.btn,
                                    url: hrefItem,
                                }}
                            >
                                {TextA.btn}
                            </EfLink>
                        </div>
                    </div>
                </div>
            </div>
        </dialog>
    );
}
